import { render, staticRenderFns } from "./r-currency-dialog.vue?vue&type=template&id=a34221f4&scoped=true"
import script from "./r-currency-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-currency-dialog.vue?vue&type=style&index=0&id=a34221f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34221f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a34221f4')) {
      api.createRecord('a34221f4', component.options)
    } else {
      api.reload('a34221f4', component.options)
    }
    module.hot.accept("./r-currency-dialog.vue?vue&type=template&id=a34221f4&scoped=true", function () {
      api.rerender('a34221f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-dialog.vue"
export default component.exports